import debounce from 'lodash.debounce';
import Swiper, { Scrollbar, A11y } from 'swiper';

Swiper.use([Scrollbar, A11y]);

interface CardCarouselSwiperProps {
    el: HTMLElement;
}

const CardCarousel = ({ el }: CardCarouselSwiperProps): void => {
    const swiperContainer: HTMLElement | null = el.querySelector('.swiper');
    const prevEl: HTMLElement | null = el.querySelector('.card-carousel-prev');
    const nextEl: HTMLElement | null = el.querySelector('.card-carousel-next');
    const items = el.querySelectorAll('.swiper-slide');
    const itemsLengthClass = items.length > 3 ? '' : 'less-than-4';
    if (itemsLengthClass) {
        el.classList.add(itemsLengthClass);
    }

    if (!swiperContainer) {
        return;
    }

    const swiperBreakpoints = {
        768: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        1280: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
    };

    const cardCarouselSwiper = new Swiper(swiperContainer, {
        init: false,
        spaceBetween: 16,
        slidesPerView: 1,
        modules: [Scrollbar],
        breakpoints: swiperBreakpoints,
        watchOverflow: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl,
            prevEl,
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
        },
    });

    cardCarouselSwiper.init();
    const windowResizeCheck = (): void => {
        setTimeout(() => {
            cardCarouselSwiper.slideReset();
            cardCarouselSwiper.update();
        }, 300);
    };

    windowResizeCheck();
    window.addEventListener('resize', debounce(windowResizeCheck, 100));
};

export default CardCarousel;
